import { Typography } from '@material-ui/core';
import React from 'react';
import { useTranslate } from 'react-admin';
import { isNullUndEmpty } from 'utils/general';

interface InfoFieldProps {
  label: string;
  value: React.ReactNode;
  labelStyle?: React.CSSProperties;
  valueStyle?: React.CSSProperties;
}

/**
 * Reusable component for displaying a label-value pair.
 * Nullish and blank-string values fall back to "N/A" (0 renders as-is).
 */
export const InfoField: React.FC<InfoFieldProps> = ({ label, value, labelStyle, valueStyle }) => {
  const translate = useTranslate();
  const isBlank = isNullUndEmpty(value);
  return (
    <Typography component="div" variant="body2" style={{ display: 'block' }}>
      <strong style={labelStyle}>{label}:</strong>{" "}
      <span style={valueStyle}>{isBlank ? translate('osfc.storage_ui.shared.missing_value') : value}</span>
    </Typography>
  );
};
